import produce from "immer";
import actionTypes from "../actionTypes/submissions";

const initialState = {};

export default function editor(state = initialState, { payload, type }) {
  const nextState = produce(state, (draft) => {
    switch (type) {
      case actionTypes.SET_SUBMISSION: {
        const { problemId } = payload;
        draft[problemId] = true;
        break;
      }
      default:
    }
  });

  return nextState;
}
